import request from '@/utils/request'

// 查询banner列表
export function belowNavigationBar(query) {
    return request({
        url: '/mhportal/slide/belowNavigationBar',
        method: 'get',
        params: query
    })
}
//查询子栏目
export function categoryList(query) {
    return request({
        url: '/mhportal/category/listByPid',
        method: 'post',
        data: query
    })
}

//查询文章列表
export function listByCat(query) {
    return request({
        url: '/mhportal/article/listByCat',
        method: 'post',
        params:{pageSize:query.pageSize,pageNum:query.pageNum},
        data: query
    })
}


//查询搜索列表
export function fuzzyList(query) {
    return request({
        url: '/mhportal/article/fuzzyList',
        method: 'post',
        data: query
    })
}

//查询文章详情
export function getInfo(query) {
    return request({
        url: '/mhportal/article/getInfo',
        method: 'post',
        data: query
    })
}
